<ng-container *transloco="let t">
  <div class="flex items-center justify-end gap-2 max-md:flex-wrap">
    <pxc-filter-bar
      data-testid="filter-bar"
      [searchPlaceholder]="t('Rechercher une séquence par mot clé, date ou patient ...')" />

    <div class="flex items-center gap-3">
      <pxc-sequence-preview-mode-segmented
        [previewMode]="sequencePreviewMode"
        (previewModeChanged)="setPreviewMode($event)" />

      @if (patient$ | async; as patient) {
        @if (hasLicenseWriteAccess$ | async) {
          <button
            data-testid="add-sequence"
            size="s"
            tuiButton
            type="button"
            [disabled]="patient.isArchived"
            (click)="addSequence(patient)">
            {{ t('Ajouter une séquence') }}
          </button>
        }
      }
    </div>
  </div>
  @if (isSequenceStateLoaded$ | async) {
    <pxc-sequence-list
      data-testid="sequence-list"
      [actions]="sequenceActions"
      [mode]="sequencePreviewMode"
      [showPatient]="sequencePreviewMode !== SequencePreviewMode.TILE"
      (sequenceMediaClicked)="openSequenceMediaGallery($event)" />
  } @else {
    <div class="mx-auto my-4">
      <pxc-loader data-testid="loading">{{ t('Récupération des photos en cours ...') }}</pxc-loader>
    </div>
  }
</ng-container>
